module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "signin-wrapper"
  }, [_c('div', {
    staticClass: "signin-container g-width-400"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeReview()
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "signin"
    }
  }, [_c('div', {
    staticClass: "u-shadow-v35 g-bg-white rounded g-px-20 g-py-20"
  }, [_c('div', {
    staticClass: "g-mb-20"
  }, [_c('label', {
    staticClass: "g-color-text-light-v1 g-font-size-16 g-font-weight-500"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.EmailAddress),
      expression: "Account.EmailAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control login_input g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12",
    attrs: {
      "name": "email",
      "oninput": "this.value = this.value.toLowerCase()",
      "type": "email",
      "data-vv-as": "email",
      "placeholder": "John@gmail.com"
    },
    domProps: {
      "value": (_vm.Account.EmailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "EmailAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
    staticClass: "g-mb-20"
  }, [_c('label', {
    staticClass: "g-color-text-light-v1 g-font-size-16 g-font-weight-500"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.Password),
      expression: "Account.Password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control login_input g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12",
    attrs: {
      "name": "password",
      "type": "password",
      "data-vv-as": "password",
      "placeholder": "**********"
    },
    domProps: {
      "value": (_vm.Account.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "Password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginfalse && !_vm.isForActivation),
      expression: "isLoginfalse && !isForActivation"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginfalse && _vm.isForActivation),
      expression: "isLoginfalse && isForActivation"
    }],
    staticClass: "error-message"
  }, [_vm._v("\n                        You need to activate your account using the activation link sent to your email. "), _c('a', {
    staticClass: "btn btn-default hover",
    staticStyle: {
      "padding": "0"
    },
    on: {
      "click": function($event) {
        return _vm.ShowResendModal()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" to resend your activation email.\n                    ")]), _vm._v(" "), (_vm.isGenericError) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("An unexpected error has occurred. Please try again in a few minutes.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('a', {
    staticClass: "btn btn-default hover g-font-size-16",
    staticStyle: {
      "padding": "0"
    },
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      }
    }
  }, [_vm._v("Forgot Password?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default login_button u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-font-size-16 rounded g-px-25 g-py-",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoginLoading
    }
  }, [_vm._v("Log In\n                        "), (_vm.isLoginLoading) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": require("../../../../static/img/loading.gif")
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "u-shadow-v35 g-bg-white rounded g-py-10 g-mt-20"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "g-color-text-light-v1 g-font-size-16 g-font-weight-500"
  }, [_vm._v("Do not have an account?")]), _vm._v(" "), _c('a', {
    staticClass: "btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-13",
    on: {
      "click": function($event) {
        return _vm.RedirectToSignUp()
      }
    }
  }, [_vm._v("Sign Up")]), _vm._v(" "), _c('a', {
    staticClass: "btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-25 g-py-13",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Demo')
      }
    }
  }, [_vm._v("View Demo")])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  })])])])]), _vm._v(" "), _c('footer-component'), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('forgot-password', {
    on: {
      "clicked": function($event) {
        return _vm.ShowModal()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isResendModalShown) ? _c('div', [_c('resend-activation', {
    attrs: {
      "RequestEmail": _vm.Account.EmailAddress
    },
    on: {
      "clicked": function($event) {
        return _vm.ShowResendModal()
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signin-header mb-3"
  }, [_c('h1', [_c('strong', [_vm._v("Login to "), _c('br'), _vm._v("Champions for Sight")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0"
  }, [_c('i', {
    staticClass: "icon-education-166 u-line-icon-pro"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0"
  }, [_c('i', {
    staticClass: "icon-finance-135 u-line-icon-pro"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4bc74044", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bc74044"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/listData/LogIn.vue
// module id = 520
// module chunks = 4